import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { IUser } from '../../models/user';
import { GetclientipdetailsService } from '../../getclientdetails/getclientipdetails.service';
//import { IAPI } from '../../base/i-api';
import { environment } from '../../../../environments/environment';

@Injectable({ providedIn: 'root' })
export class AuthenticationService {

  private baseUrl: string = environment.baseUrl;
  private currentUserSubject: BehaviorSubject<IUser>;
  public currentUser: Observable<IUser>;

  constructor(private http: HttpClient, private _ipClientService: GetclientipdetailsService) {
    this.currentUserSubject = new BehaviorSubject<IUser>(JSON.parse(localStorage.getItem('currentUser')));
    this.currentUser = this.currentUserSubject.asObservable();
  }

  private getClientDetails(): void {

    this._ipClientService.getIPDetails().subscribe(
      data => {
        if (data.country)
        {
          localStorage.setItem('clientCountryCode', data.country);
        }
      }
    );

  }

  public get currentUserValue(): IUser {
    return this.currentUserSubject.value;
  }

  login(username: string, password: string) {
    let partner = {
      partner: {
        email: username,
        password: password
      }
    }
    return this.http.post<any>(`${this.baseUrl}/login`, partner)
    //return this.http.post<any>(`login`, partner)
      .pipe(map(user => {
        // store user details and jwt token in local storage to keep user logged in between page refreshes
        if (!user.error) {
          localStorage.setItem('currentUser', JSON.stringify(user));
          this.currentUserSubject.next(user);
          this.getClientDetails();
        }
        return user;
      }));
  }

  logout() {
    // remove user from local storage to log user out
    //localStorage.removeItem('currentUser');
    localStorage.clear();
    this.currentUserSubject.next(null);
  }

  public forgetPassword(value) {
    let partner = {
      emailId: value.email,
    }
    return this.http.put<any>(`${this.baseUrl}/forgotPassword`, partner)
      .pipe(map(reset => {
        // store user details and jwt token in local storage to keep user logged in between page refreshes
        if (!reset.error) {
          return reset;
        }
      }));
  }

}
